const SessionRecordContent = () => (
    <div className='flex flex-col gap-[7px]' data-testid="login-session-record-content">
        <span className='block font-dmSansBold font-bold text-16 leading-[125%] text-black'>
            Let's improve MedBox together
        </span>
        <span data-testid="login-session-record-content" className="font-atkinsonHyperlegible text-16 leading-[130%]">
            Enable session recording to help us improve your experience.{' '}
            <a
                target="_blank"
                className="cursor-pointer font-atkinsonBold font-bold text-black underline"
                href="https://medbox.com/cookie-policy/"
                style={{ fontWeight: '700' }}
            >
                Cookie Policy
            </a>
        </span>
    </div>
);

export default SessionRecordContent;
